import { Component, Prop, Ref, Vue } from 'vue-property-decorator';
import FormBookDemo from '@/components/forms/form-book-demo.vue'
import FormLogin from '@/components/forms/form-login.vue';
import TheHeader from '@/components/headers/the-header.vue';


@Component({
  components: {
    FormBookDemo,
    FormLogin,
    TheHeader,
  },
})
export default class InvalidSessionView extends Vue {
  @Ref() contactContainer: HTMLDivElement;

  scrollToContact() {
    if (this.contactContainer) {
      this.contactContainer.scrollIntoView();
    }
  }
}
